import blog1 from "../assets/images/blog/1.avif"
import blog2 from "../assets/images/blog/2.jpg"
import blog3 from "../assets/images/blog/3.jpg"
import blog4 from "../assets/images/blog/4.jpg"
import blog5 from "../assets/images/blog/5.jpg"
import blog6 from "../assets/images/blog/6.jpg"
import blog7 from "../assets/images/blog/7.jpg"
import blog8 from "../assets/images/blog/8.jpg"
import blog9 from "../assets/images/blog/9.jpg"
import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'
import client7 from '../assets/images/client/07.jpg'
import client8 from '../assets/images/client/08.jpg'


export const blogData = [
    {
        id:1,
        image:blog1,
        title:'Projeto 1',
        date:'Sep 13, 2023'
    },
    {
        id:2,
        image:blog1,
        title:'Projeto 2',
        date:'Nov 29, 2023'
    },
    {
        id:3,
        image:blog1,
        title:'Projeto 3',
        date:'Dec 29, 2023'
    },
]